// Yeni talep açılırken: KVKK onaysız mağazaya önce uyarı + kalan hak; hak bittiyse engel
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { AlertTriangle, Ban } from 'lucide-react';
import { StoreKvkkCard } from './StoreKvkkCard';
import { QuotaText, useStoreQuota } from './StoreFirstLoginPrompt';

export const StoreQuotaGate = ({ enabled }) => {
  const navigate = useNavigate();
  const [quota, load] = useStoreQuota(enabled);
  const [open, setOpen] = useState(false);
  useEffect(() => { if (quota?.is_store && !quota.unlimited) setOpen(true); }, [quota?.is_store, quota?.unlimited]);
  if (!enabled || !quota?.is_store || quota.unlimited) return null;
  const blocked = quota.remaining <= 0;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { if (blocked) navigate('/work-permits'); else setOpen(false); } }}>
      <DialogContent className="max-w-lg" data-testid="store-quota-gate">
        <DialogHeader>
          <DialogTitle className={`flex items-center gap-2 ${blocked ? 'text-rose-700' : 'text-amber-800'}`}>
            {blocked ? <Ban className="h-5 w-5" /> : <AlertTriangle className="h-5 w-5" />}{blocked ? 'Talep hakkınız doldu' : 'KVKK belgeleriniz onaylanmadı'}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600"><QuotaText quota={quota} /></p>
        {blocked && quota.kvkk_state !== 'beklemede' && <p className="text-sm text-rose-700">Yeni talep gönderebilmek için KVKK Taahhütnamesi ve Aydınlatma Yükümlülüğü belgelerini yükleyip İSG onayını beklemeniz gerekir.</p>}
        <StoreKvkkCard quota={quota} onUploaded={load} />
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => navigate('/work-permits')} data-testid="store-quota-back">Geri Dön</Button>
          {!blocked && <Button onClick={() => setOpen(false)} className="bg-slate-900 hover:bg-slate-800" data-testid="store-quota-continue">Anladım, Devam Et</Button>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
